import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'

import SvgIcon from 'Components/SvgIcon'

import PropertyType from '../PropertyType'
import Commute from '../Commute'
import OtherStats from './component/OtherStats'

import { _ExtraStats, _ToggleCta } from './styles.js'

export const TEST_IDS = {
  TOGGLE_BTN: 'toggleBtn',
}

const ExtraStats = ({ data, googleAnalyticsEvent, source, areaName }) => {
  const [isExtraVisible, toggleExtra] = useState(false)
  return (
    <Fragment>
      <_ExtraStats isVisible={isExtraVisible}>
        <PropertyType data={data} areaName={areaName} />
        <Commute data={data} />
        <OtherStats data={data} />
      </_ExtraStats>
      <_ToggleCta
        onClick={() => {
          toggleExtra(isVisible => !isVisible)
          googleAnalyticsEvent({
            category: source,
            action: [
              `Demographics Extra Click ${!isExtraVisible ? 'Show' : 'Hide'}`,
            ],
          })
        }}
        justify="center"
        align="center"
        isExtraVisible={isExtraVisible}
        data-test-id={TEST_IDS.TOGGLE_BTN}
      >
        {isExtraVisible ? 'Hide' : 'View'} property type, commute, languages, education & average income
        <SvgIcon
          name="#icon-dropdown-arrow"
          width={13}
        />
      </_ToggleCta>
    </Fragment>
  )
}

ExtraStats.defaultProps = {
  googleAnalyticsEvent: () => {},
}

ExtraStats.propTypes = {
  data: PropTypes.shape({}),
  googleAnalyticsEvent: PropTypes.func,
  source: PropTypes.string,
  areaName: PropTypes.string,
}

export default ExtraStats
